"use client";

import { SliderWrapper } from "@/components/common/slider-wrapper";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { ProfileNoImage } from "@/components/common/profile-no-image";
import Link from "next/link";
import { createPath } from "@/service/routing/routing";

export const AuthorSlider = ({ authors }: { authors: ProfileVM[] }) => {
  const [api, setApi] = useState<CarouselApi | null>(null);

  return (
    <div className={"relative"}>
      <Link
        href={createPath("editorial")}
        className={"absolute-link inset-0"}
      ></Link>
      <SliderWrapper api={api} extraScrollMoveMobile={true}>
        <Carousel
          opts={{
            skipSnaps: true,
          }}
          setApi={setApi}
          plugins={[WheelGesturesPlugin()]}
        >
          <CarouselContent>
            {authors.map((author, index) => (
              <CarouselItem
                className={cn("basis-[120px]")}
                isFirst={index === 0}
                key={author.name}
                isLast={index === authors.length - 1}
              >
                <AuthorSlide author={author} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </SliderWrapper>
    </div>
  );
};

const AuthorSlide = ({
  author: { image, prefix, name, slug },
}: {
  author: ProfileVM;
}) => (
  <div
    className={"relative flex flex-col items-center justify-start text-center"}
  >
    <div className={"mb-4 h-[84px] w-[84px] overflow-hidden rounded-full"}>
      {image ? (
        <PictureUpload
          image={image}
          className={"h-[84px]"}
          pictureClassName={"h-[84px]"}
          wrapperClassName={"h-[84px]"}
        />
      ) : (
        <ProfileNoImage
          className={
            "bg-secondary text-muted-foreground h-[84px] w-[84px] text-base"
          }
          displayName={name}
        />
      )}
    </div>
    {prefix && (
      <div className={`text-muted-foreground mb-1.5 text-sm font-normal`}>
        {prefix}
      </div>
    )}
    <div className={`text-foreground text-sm font-semibold`}>{name}</div>
  </div>
);
